module.exports = __webpack_public_path__ + "static/media/anc17kz.1b60645b.pdf";